export const SortBy = Object.freeze({
  ASSESSMENT: 'assessment_date',
  CHECK_IN: 'check_in',
  PATIENT_NAME: 'patient_name',
  DATE_OF_NEXT_APPT: 'date_of_next_appt',
  DATE_OF_INVITE: 'date_of_invite',
  CREATED_AT: 'created_at',
  ARCHIVED_DATE: 'archived_date'
})
